export enum EUserSelectorMode {
    Add = 'add',
    Email = 'email',
}
